import React from 'react'
import DefaultLayout from '../layouts/default';
import PolicyModal from '../components/policy-modal/policy';

export default function PolicyPage() {
  return (
    <DefaultLayout>
        <PolicyModal></PolicyModal>
    </DefaultLayout>
  )
}

 
